import axios, { AxiosInstance, CancelToken, AxiosRequestConfig, AxiosResponse } from "axios";
import { isAxiosError, throwException } from "../ShoppingCart/ShoppingCartClient";

export class TransactionClient {
    protected instance: AxiosInstance;
    protected baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(baseUrl?: string, instance?: AxiosInstance) {

        this.instance = instance || axios.create();
        this.instance.interceptors.request.use(
          config => {
              const token = localStorage.getItem('accessToken');
              if (token) {
                  if (!config.headers) {
                      config.headers = {};
                  }
                  config.headers['Authorization'] = `Bearer ${token}`;
              }
              return config;
          },
          error => {
              return Promise.reject(error);
          }
      );
        this.baseUrl = baseUrl ?? "";
  
    }

    /**
     * @param shoppingCartIdentity (optional) 
     * @return OK
     */
    checkreimbursmentavailabilty(shoppingCartIdentity?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/transaction/checkreimbursmentavailabilty?";
        if (shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' cannot be null.");
        else if (shoppingCartIdentity !== undefined)
            url_ += "shoppingCartIdentity=" + encodeURIComponent("" + shoppingCartIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCheckreimbursmentavailabilty(_response);
        });
    }

    protected processCheckreimbursmentavailabilty(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }

    /**
     * @param shoppingCartIdentity (optional) 
     * @return OK
     */
    reimbursment(shoppingCartIdentity?: string | undefined, cancelToken?: CancelToken): Promise<boolean> {
        let url_ = this.baseUrl + "/api/transaction/reimbursment?";
        if (shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' cannot be null.");
        else if (shoppingCartIdentity !== undefined)
            url_ += "shoppingCartIdentity=" + encodeURIComponent("" + shoppingCartIdentity) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "GET",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReimbursment(_response);
        });
    }

    protected processReimbursment(response: AxiosResponse): Promise<boolean> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<boolean>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<boolean>(null as any);
    }
    /**
     * @return OK
     */
    initiate(paymentTypeTag: string, shoppingCartIdentity: string, cancelToken?: CancelToken): Promise<string> {
        let url_ = this.baseUrl + "/api/transaction/initiate/{paymentTypeTag}/{shoppingCartIdentity}";
        if (paymentTypeTag === undefined || paymentTypeTag === null)
            throw new Error("The parameter 'paymentTypeTag' must be defined.");
        url_ = url_.replace("{paymentTypeTag}", encodeURIComponent("" + paymentTypeTag));
        if (shoppingCartIdentity === undefined || shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' must be defined.");
        url_ = url_.replace("{shoppingCartIdentity}", encodeURIComponent("" + shoppingCartIdentity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
                "Accept": "text/plain"
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processInitiate(_response);
        });
    }

    protected processInitiate(response: AxiosResponse): Promise<string> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 400) {
            return Promise.reject(new Error("already_paid"));
        }

        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
                result200 = resultData200 !== undefined ? resultData200 : <any>null;
    
            return Promise.resolve<string>(result200);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<string>(null as any);
    }

     /**
     * @return OK
     */
    simulate(paymentTypeTag: string, shoppingCartIdentity: string, cancelToken?: CancelToken): Promise<void> {
        let url_ = this.baseUrl + "/api/transaction/simulate/{paymentTypeTag}/{shoppingCartIdentity}";
        if (paymentTypeTag === undefined || paymentTypeTag === null)
            throw new Error("The parameter 'paymentTypeTag' must be defined.");
        url_ = url_.replace("{paymentTypeTag}", encodeURIComponent("" + paymentTypeTag));
        if (shoppingCartIdentity === undefined || shoppingCartIdentity === null)
            throw new Error("The parameter 'shoppingCartIdentity' must be defined.");
        url_ = url_.replace("{shoppingCartIdentity}", encodeURIComponent("" + shoppingCartIdentity));
        url_ = url_.replace(/[?&]$/, "");

        let options_: AxiosRequestConfig = {
            method: "POST",
            url: url_,
            headers: {
            },
            cancelToken
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSimulate(_response);
        });
    }

    protected processSimulate(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (const k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(null as any);

        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(null as any);
    }
}